import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'

import { Slider } from '@/widgets/slider'

import { Button } from '@/shared/ui'

import cl from './BannerSliderSert.module.scss'

export interface BannerProps {}

const sliderImages = [
	`https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/1.png`,
	`https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/2.png`,
	`https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/3_v2.png`,
	`https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/4.png`,
	`https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/5.png`
]

export const BannerSliderSert: FC<BannerProps> = () => {
	return (
		<div style={{ position: 'relative', paddingTop: `30px` }}>
			<div className={cl.root}>
				<Slider
					className={cl.slider}
					autoplay={false}
					slides={sliderImages.map(src => (
						<Image
							src={src}
							key={src}
							alt=""
							width={598}
							height={460}
							className={clsx(cl.img, cl.img_desktop)}
							priority={true}
						/>
					))}
				/>

				<div className={cl.content}>
					<span className={cl.topTextWrap}>
						<span className={cl.topText}>Лимитированное предложение</span>
					</span>
					<p className={cl.title}>
						iPhone 17 + Limited Box
						<span className={cl.titleCounter}>100 шт.</span>
					</p>
					<p className={cl.discount}> 7 990 ₽</p>
					<p className={cl.price}>+ стоимость iPhone 17 </p>

					<Button
						size="L"
						as="a"
						href="/catalog/apple_iphone/filter/seriya_5-is-282116145_2057871256-or-282116145_1849902554/"
						className={cl.button}>
						Выбрать iPhone
					</Button>

					{/*<Link prefetch={false} href="/apple_iphone/filter/all_iphone_17/" className={cl.button}>*/}
					{/*	Выбрать iPhone*/}
					{/*</Link>*/}

					<p className={cl.listTitle}>Cостав бокса:</p>
					<ol className={cl.list}>
						<li className={cl.listItem}>Уникальная коробка с порядковым номером от 1 до 100</li>
						<li className={cl.listItem}>Предусмотренное место для вложения нового iPhone 17</li>
						<Link prefetch={false} href={'/products/productID148731/'}>
							<li className={cl.listItem}>
								Внешний аккумулятор c БЗУ VLP Diamond Energy на 5000 мАч — <b>5 995 ₽</b> <s>6 990 ₽</s>
							</li>
						</Link>
						<Link prefetch={false} href={'/products/productID147021/'}>
							<li className={cl.listItem}>
								Зарядное устройство сетевое VLP G-Charge USB-C на 45Вт — <b>1 995 ₽</b> <s>2 490 ₽</s>
							</li>
						</Link>
						<li className={cl.listItem}>Набор лимитированных стикеров и открытка с пожеланиями</li>
					</ol>
				</div>
			</div>
			<div className={cl.topTip}>
				Оформляя предзаказ вместе с Limited Box, вы&nbsp;получите заказ с iPhone 17 в числе первых.
			</div>
		</div>
	)
}
